import React from "react";
import { AbsoluteFill, interpolate, spring, useCurrentFrame, useVideoConfig } from "remotion";
import { COLORS, FONTS, SPRING } from "./constants";
import { Backdrop, glow } from "./shared";

const SOURCES = [
  { icon: "📦", name: "GitHub",     detail: "batch_runner.py · redis_shards.py",  c: COLORS.neonPurple, check: 30 },
  { icon: "💬", name: "Slack",      detail: "#architecture · 2026-01-14 thread",  c: COLORS.neonPink,    check: 55 },
  { icon: "📘", name: "Confluence", detail: "/batch-design · architecture-2026",  c: COLORS.neonBlue,    check: 80 },
  { icon: "📄", name: "PDFs",       detail: "worker-pool-spec-v3.pdf · §4.2",     c: COLORS.neonYellow,  check: 105 },
];

export const Scene4Sources: React.FC = () => {
  const frame = useCurrentFrame();
  const { fps, durationInFrames } = useVideoConfig();

  const fade = interpolate(frame, [durationInFrames - 20, durationInFrames], [1, 0], {
    extrapolateLeft: "clamp", extrapolateRight: "clamp",
  });

  const labelSp = spring({ frame, fps, config: SPRING.gentle });
  const labelOp = interpolate(labelSp, [0, 1], [0, 1], { extrapolateLeft: "clamp", extrapolateRight: "clamp" });

  return (
    <AbsoluteFill style={{ background: COLORS.bg, opacity: fade, overflow: "hidden" }}>
      <Backdrop frame={frame} accent={COLORS.neonGreen} />

      <div style={{
        position: "absolute", top: 90, left: 0, right: 0,
        textAlign: "center",
        opacity: labelOp,
      }}>
        <div style={{
          fontSize: 52,
          fontFamily: FONTS.heading,
          fontWeight: 900,
          color: COLORS.textPrimary,
          textShadow: `0 0 30px ${COLORS.neonGreen}aa`,
          letterSpacing: -1,
        }}>
          Every answer — <span style={{ color: COLORS.neonGreen, textShadow: glow(COLORS.neonGreen, true) }}>sourced.</span>
        </div>
      </div>

      {/* 4 source rows */}
      <div style={{
        position: "absolute", top: 240, left: 0, right: 0,
        display: "flex", flexDirection: "column",
        alignItems: "center",
        gap: 30,
      }}>
        {SOURCES.map((s, i) => {
          const sp = spring({ frame: frame - 20 - i * 20, fps, config: SPRING.gentle });
          const op = interpolate(sp, [0, 1], [0, 1], { extrapolateLeft: "clamp", extrapolateRight: "clamp" });
          const tx = interpolate(sp, [0, 1], [-100, 0], { extrapolateLeft: "clamp", extrapolateRight: "clamp" });

          const checkSp = spring({ frame: frame - s.check, fps, config: SPRING.punch });
          const checkSc = interpolate(checkSp, [0, 1], [0, 1], { extrapolateLeft: "clamp", extrapolateRight: "clamp" });

          return (
            <div key={s.name} style={{
              width: 1200,
              height: 120,
              opacity: op,
              transform: `translateX(${tx}px) perspective(1200px) rotateY(${Math.sin(frame * 0.01 + i) * 3}deg)`,
              background: `linear-gradient(135deg, ${s.c}18, ${COLORS.bgCard}ee)`,
              border: `2px solid ${s.c}80`,
              borderLeft: `6px solid ${s.c}`,
              borderRadius: 18,
              display: "flex",
              alignItems: "center",
              gap: 32,
              padding: "0 40px",
              boxShadow: `0 0 30px ${s.c}55`,
            }}>
              <div style={{ fontSize: 60 }}>{s.icon}</div>
              <div style={{ flex: 1 }}>
                <div style={{
                  fontSize: 32,
                  fontFamily: FONTS.heading,
                  fontWeight: 800,
                  color: s.c,
                  textShadow: glow(s.c),
                }}>{s.name}</div>
                <div style={{
                  fontSize: 20,
                  fontFamily: FONTS.mono,
                  color: COLORS.textSecondary,
                  marginTop: 4,
                }}>{s.detail}</div>
              </div>
              {/* Check */}
              <div style={{
                width: 72,
                height: 72,
                borderRadius: "50%",
                background: `${COLORS.neonGreen}22`,
                border: `3px solid ${COLORS.neonGreen}`,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 42,
                color: COLORS.neonGreen,
                textShadow: glow(COLORS.neonGreen, true),
                transform: `scale(${checkSc})`,
                boxShadow: `0 0 30px ${COLORS.neonGreen}88`,
              }}>
                ✓
              </div>
            </div>
          );
        })}
      </div>
    </AbsoluteFill>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
